import { createOccurrenceKey } from './recurrence';

export const RECURRENCE_MATERIALIZATION_ERROR_CODES = Object.freeze({
  INVALID_OCCURRENCE: 'INVALID_RECURRING_OCCURRENCE',
  INVALID_STATUS: 'INVALID_RECURRING_MATERIALIZATION_STATUS',
  SEGMENT_CANCELLED: 'RECURRING_SEGMENT_CANCELLED',
  OCCURRENCE_SKIPPED: 'RECURRING_OCCURRENCE_SKIPPED',
  TRANSACTION_WITHOUT_STATE: 'RECURRING_TRANSACTION_WITHOUT_STATE',
  STATE_TRANSACTION_MISMATCH: 'RECURRING_STATE_TRANSACTION_MISMATCH',
  STATE_TRANSACTION_MISSING: 'RECURRING_STATE_TRANSACTION_MISSING',
  STATE_INCONSISTENT: 'RECURRING_OCCURRENCE_STATE_INCONSISTENT',
  UPDATE_INVALID_TRANSACTION: 'INVALID_RECURRING_OCCURRENCE_UPDATE',
  UPDATE_STATE_MISSING: 'RECURRING_UPDATE_STATE_MISSING',
  UPDATE_NOT_MATERIALIZED: 'RECURRING_UPDATE_NOT_MATERIALIZED',
  UPDATE_TRANSACTION_MISMATCH: 'RECURRING_UPDATE_TRANSACTION_MISMATCH',
  UPDATE_TRANSACTION_MISSING: 'RECURRING_UPDATE_TRANSACTION_MISSING',
  UPDATE_SEGMENT_MISSING: 'RECURRING_UPDATE_SEGMENT_MISSING',
  UPDATE_SEGMENT_MISMATCH: 'RECURRING_UPDATE_SEGMENT_MISMATCH',
  UPDATE_TYPE_MISMATCH: 'RECURRING_UPDATE_TYPE_MISMATCH',
});

export class RecurrenceMaterializationError extends Error {
  constructor(code, details = []) {
    super(code);
    this.name = 'RecurrenceMaterializationError';
    this.code = code;
    this.details = details;
  }
}

/**
 * A identidade deriva da ocorrência agendada original, nunca da data efetiva.
 * O resultado usa apenas caracteres seguros para IDs de documento do Firestore.
 */
export const createRecurringTransactionId = (seriesId, scheduledDate) => (
  `rec_${createOccurrenceKey(seriesId, scheduledDate)}`
);
